import { __assign, __extends, __rest } from "tslib";
import * as React from 'react';
import { StyleSheet, View } from 'react-native';
/**
 * A component to show content inside a Card.
 *
 * ## Usage
 * ```js
 * import * as React from 'react';
 * import { PnmacCard, PnmacTitle, PnmacParagraph } from 'pnmac-universal-components';
 *
 * const MyComponent = () => (
 *   <PnmacCard>
 *     <PnmacCard.Content>
 *       <PnmacTitle>Card title</PnmacTitle>
 *       <Paragraph>Card content</Paragraph>
 *     </PnmacCard.Content>
 *   </PnmacCard>
 * );
 *
 * export default MyComponent;
 * ```
 */
var PnmacCardContent = /** @class */function (_super) {
  __extends(PnmacCardContent, _super);
  function PnmacCardContent() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  PnmacCardContent.prototype.render = function () {
    var _a = this.props,
      index = _a.index,
      total = _a.total,
      siblings = _a.siblings,
      style = _a.style,
      rest = __rest(_a, ["index", "total", "siblings", "style"]);
    var cover = 'withTheme(CardCover)';
    var title = 'withTheme(CardTitle)';
    var contentStyle, prev, next;
    if (typeof index === 'number' && siblings) {
      prev = siblings[index - 1];
      next = siblings[index + 1];
    }
    if (prev === cover && next === cover || prev === title && next === title || total === 1) {
      contentStyle = styles.only;
    } else if (index === 0) {
      if (next === cover || next === title) {
        contentStyle = styles.only;
      } else {
        contentStyle = styles.first;
      }
    } else if (typeof total === 'number' && index === total - 1) {
      if (prev === cover || prev === title) {
        contentStyle = styles.only;
      } else {
        contentStyle = styles.last;
      }
    } else if (prev === cover || prev === title) {
      contentStyle = styles.first;
    } else if (next === cover || next === title) {
      contentStyle = styles.last;
    }
    return /*#__PURE__*/React.createElement(View, __assign({}, rest, {
      style: [styles.container, contentStyle, style],
      nativeID: rest.idTag1
    }));
  };
  PnmacCardContent.displayName = 'PnmacCard.Content';
  return PnmacCardContent;
}(React.Component);
var styles = StyleSheet.create({
  container: {
    paddingHorizontal: 16
  },
  first: {
    paddingTop: 16
  },
  last: {
    paddingBottom: 16
  },
  only: {
    paddingVertical: 16
  }
});
export default PnmacCardContent;